var map = {
	"./AI-Chat-24px.svg": 69902,
	"./CarInsuranceIcon.svg": 30651,
	"./IconCheck.svg": 28987,
	"./L-Arrow-24px.svg": 85813,
	"./LinkIcon.svg": 56453,
	"./Wallet-24px.svg": 82180,
	"./arrow-left.svg": 48609,
	"./basket.svg": 81944,
	"./bell.svg": 95853,
	"./budget-plan-icon.svg": 59887,
	"./check-tick.svg": 66460,
	"./close-24px.svg": 44221,
	"./dot.svg": 34691,
	"./excluded.svg": 96392,
	"./icon-calendar.svg": 54888,
	"./icon-chat.svg": 25432,
	"./icon-document.svg": 47353,
	"./icons/face-smile-purple.svg": 61954,
	"./info-16px.svg": 20002,
	"./lightning.svg": 48848,
	"./linkaccount/feature-card.svg": 70363,
	"./linkaccount/feature-save.svg": 33998,
	"./linkaccount/feature-secure.svg": 4890,
	"./lock.svg": 76807,
	"./logos/MGLogo.svg": 24572,
	"./logos/TrueLayer.svg": 80260,
	"./logos/amex.svg": 66032,
	"./logos/bankofscotland.svg": 51876,
	"./logos/barclays.svg": 13826,
	"./logos/capitalone.svg": 78037,
	"./logos/firstdirect.svg": 8894,
	"./logos/halifax.svg": 79394,
	"./logos/hsbc.svg": 39115,
	"./logos/lloyds.svg": 28606,
	"./logos/mbna.svg": 7015,
	"./logos/metro.svg": 31752,
	"./logos/monese.svg": 48218,
	"./logos/monzo.svg": 39384,
	"./logos/ms.svg": 4053,
	"./logos/nationwide.svg": 72429,
	"./logos/natwest.svg": 4967,
	"./logos/paragon.svg": 99209,
	"./logos/revolut.svg": 83558,
	"./logos/santander.svg": 8003,
	"./logos/starling.svg": 59817,
	"./logos/temp_charliehr.svg": 80498,
	"./logos/temp_peoplepension.svg": 18079,
	"./logos/temp_shopst.svg": 8059,
	"./logos/temp_unum.svg": 95273,
	"./logos/temp_vitality.svg": 17352,
	"./logos/tesco.svg": 90197,
	"./logos/tide.svg": 24761,
	"./logos/tsb.svg": 21620,
	"./logos/virginmoney.svg": 96158,
	"./menu-burger-24px.svg": 20826,
	"./menu/Activity.svg": 4097,
	"./menu/ActivityOn.svg": 37306,
	"./menu/Guide.svg": 3970,
	"./menu/GuideOn.svg": 36589,
	"./menu/Home.svg": 99499,
	"./menu/HomeOn.svg": 69596,
	"./menu/Money.svg": 36394,
	"./menu/MoneyOn.svg": 49077,
	"./menu/You.svg": 55051,
	"./menu/YouOn.svg": 12156,
	"./menu/vertical-dots.svg": 64445,
	"./quiz/peel-large.svg": 15416,
	"./refresh-cw.svg": 80362,
	"./signin/bullet-bill.svg": 18791,
	"./signin/bullet-card.svg": 458,
	"./signin/bullet-goals.svg": 21392,
	"./signin/field-clear-20px.svg": 3288,
	"./signin/help-avatar.svg": 73696,
	"./signin/info-16px.svg": 2609,
	"./signin/info-green-16px.svg": 15275,
	"./signin/info-red-16px.svg": 51783,
	"./signin/logomark.svg": 63637,
	"./signin/wordmark.svg": 81012,
	"./spendCategories/Bills.svg": 41877,
	"./spendCategories/Clothes.svg": 16483,
	"./spendCategories/Coffee.svg": 55901,
	"./spendCategories/CreditCards.svg": 61363,
	"./spendCategories/Dark_excludedFromAnalysisIcon.svg": 45443,
	"./spendCategories/Debts.svg": 14205,
	"./spendCategories/Drinks.svg": 25972,
	"./spendCategories/EatingOut.svg": 76409,
	"./spendCategories/Education.svg": 38177,
	"./spendCategories/Entertainment.svg": 84025,
	"./spendCategories/Family.svg": 26993,
	"./spendCategories/Fitness.svg": 87539,
	"./spendCategories/Gambling.svg": 53152,
	"./spendCategories/Gifts.svg": 4182,
	"./spendCategories/Groceries.svg": 50194,
	"./spendCategories/Holiday.svg": 61683,
	"./spendCategories/Home&Garden.svg": 66133,
	"./spendCategories/Home.svg": 43968,
	"./spendCategories/Insurance.svg": 48687,
	"./spendCategories/InternalTransfers.svg": 35466,
	"./spendCategories/InternalTransfersIcon.svg": 32137,
	"./spendCategories/Investments.svg": 72625,
	"./spendCategories/LargePurchases.svg": 66126,
	"./spendCategories/Medical.svg": 42974,
	"./spendCategories/Other.svg": 67933,
	"./spendCategories/Pets.svg": 73411,
	"./spendCategories/Resources.svg": 58596,
	"./spendCategories/Salary.svg": 89531,
	"./spendCategories/Savings.svg": 41338,
	"./spendCategories/Selfcare.svg": 19908,
	"./spendCategories/Shopping.svg": 55617,
	"./spendCategories/Socialising.svg": 38628,
	"./spendCategories/Takeaways.svg": 73977,
	"./spendCategories/Transport.svg": 64360,
	"./spendCategories/Travel.svg": 22501,
	"./spendCategories/Uncategorized.svg": 40225,
	"./spendCategories/Vehicle.svg": 1723,
	"./transactions/benefits.svg": 73900,
	"./transactions/bills.svg": 56782,
	"./transactions/charity.svg": 65040,
	"./transactions/clothes.svg": 4640,
	"./transactions/clothing.svg": 42964,
	"./transactions/coffee.svg": 48484,
	"./transactions/coffees.svg": 3023,
	"./transactions/creditcards.svg": 57068,
	"./transactions/dark_excludedfromanalysisicon.svg": 61516,
	"./transactions/debts.svg": 32718,
	"./transactions/drinks.svg": 99025,
	"./transactions/eatingout.svg": 92030,
	"./transactions/education.svg": 74170,
	"./transactions/entertainment.svg": 85714,
	"./transactions/essentials.svg": 37407,
	"./transactions/family.svg": 4472,
	"./transactions/fitness.svg": 93672,
	"./transactions/future.svg": 83845,
	"./transactions/gambling.svg": 60361,
	"./transactions/general.svg": 62464,
	"./transactions/gifts.svg": 42389,
	"./transactions/groceries.svg": 75757,
	"./transactions/health.svg": 71290,
	"./transactions/hobbies.svg": 77368,
	"./transactions/holiday.svg": 30860,
	"./transactions/home&garden.svg": 44186,
	"./transactions/home.svg": 39389,
	"./transactions/income.svg": 21337,
	"./transactions/insurance.svg": 83412,
	"./transactions/insurances.svg": 92639,
	"./transactions/insurnace.svg": 11206,
	"./transactions/interest.svg": 52990,
	"./transactions/internaltransfers.svg": 86009,
	"./transactions/internaltransfersicon.svg": 33990,
	"./transactions/investments.svg": 70678,
	"./transactions/largepurchases.svg": 10459,
	"./transactions/lifestyle.svg": 26493,
	"./transactions/medical.svg": 16381,
	"./transactions/mortgage.svg": 73470,
	"./transactions/other.svg": 5574,
	"./transactions/pension in.svg": 23007,
	"./transactions/pension out.svg": 12330,
	"./transactions/pensionin.svg": 93051,
	"./transactions/pensionout.svg": 88126,
	"./transactions/pets.svg": 76730,
	"./transactions/rent.svg": 65241,
	"./transactions/resources.svg": 84839,
	"./transactions/salary.svg": 63558,
	"./transactions/savings.svg": 38693,
	"./transactions/selfcare.svg": 25817,
	"./transactions/shopping.svg": 87820,
	"./transactions/socialising.svg": 77411,
	"./transactions/sports and fitness.svg": 52638,
	"./transactions/sportsandfitness.svg": 77964,
	"./transactions/takeaways.svg": 1822,
	"./transactions/transfers.svg": 93272,
	"./transactions/transport.svg": 40231,
	"./transactions/travel.svg": 12668,
	"./transactions/uncategorised.svg": 25871,
	"./transactions/vehicle.svg": 59544,
	"./transactions/withdrawals-1.svg": 91930,
	"./transactions/withdrawals.svg": 6452,
	"./transactions/work.svg": 57999,
	"./vouchers-in-store.svg": 65861,
	"./vouchers-online.svg": 62081,
	"./whatsapp.svg": 46144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;